export { default as Log } from './Log';
export { default as Device } from './Device';
export { default as Cookie } from './Cookie';
export { default as Request } from './Request';
export { default as Random } from './Random';
export { default as Wechat } from './Wechat';
export { default as Bridge } from './Bridge';
export { default as LocalStorage } from './LocalStorage';

export const IS_PROD = process.env.NODE_ENV === 'production';
/* eslint-disable */
/**
 * [Get More](https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript)
 */
function uuidv4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}

/* eslint-enable */
export const uuid = uuidv4;

export const encryptPhone = (str = '') => String(str).replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3');


/**
 * 拼凑路由参数
 * */
export function setRouteParam(options = {}) {
  return Object.keys(options).reduce((prev, next) => {
    prev.push(`${next}=${encodeURIComponent(options[next])}`);
    return prev;
  }, []).join('&');
}

function add0(m) {
  return m < 10 ? `0${m}` : m;
}

export function formatTime(shijianchuo) {
  const timeMs = shijianchuo || +(new Date()).getTime();
  const time = new Date(timeMs);
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  const h = time.getHours();
  const mm = time.getMinutes();
  const s = time.getSeconds();
  return `${y}-${add0(m)}-${add0(d)} ${add0(h)}:${add0(mm)}:${add0(s)}.${timeMs % 1000}`;
}

/**
 * base64编码转blob
 * @param {Base64} base64Data
 * @returns {Blob}
 */
export function base64toBlob(base64Data, type = 'png') {
  const byteString = window.atob(base64Data.split(',')[1]);
  const ab = new window.ArrayBuffer(byteString.length);
  const ia = new window.Uint8Array(ab);
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new window.Blob([ab], {
    type: `image/${type}`,
  });
}

/**
 * 判断所处环境
 * @return {String} wx_app 微信小程序／app C端APP
 */
export const getSource = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  let source = '';
  if (/micromessenger/i.test(ua)) {
    source = 'wx_app';
  } else {
    source = 'app';
  }
  return source;
};



// WEBPACK FOOTER //
// ./src/utils/index.js